import NoPermissionMessage from './NoPermissionMessage';
import { checkForPermission } from '../../util/permissionUtils';

interface ProtectedRouteProps {
  children: any;
  apiPermissions: string[];
}
const ProtectRoute = ({ children, apiPermissions = [] }: ProtectedRouteProps) => {
  return checkForPermission(apiPermissions) ? children : <NoPermissionMessage />;
};

export default ProtectRoute;
